<template>
  <div>
    <div >
      <el-table
        :data="salesOrders"
        stripe
        :fit="true"
        :height="height"
        :default-sort="{ prop: sortProp, order: sortOrder }"
        @sort-change="handleSortChange"
        style="width: 100%;"
        :cell-style="{padding:'2px'}">
        <div slot="empty">
          <span>{{$t('sales_orders.no_sales_orders')}}</span>
        </div>
        <el-table-column
          width="50"
          fixed>
          <template slot-scope="scope">
            
            <status-indicator class="ml-10"
              :positive="isPositive(scope.row)"
              :intermediary="isIntermediary(scope.row)"
              :negative="isNegative(scope.row)"
              pulse
            />

          </template>
        </el-table-column>
        <el-table-column
        prop="id"
        fixed
        text-align="center"
        width="60">
        <template slot-scope="scope">
           <span v-if="isB2B(scope.row)" class="ml-5 fs-14 secondary-text">
              <el-image src="/logo-panorama.png" style="height:16px;"></el-image>
            </span>
        </template>
      </el-table-column>
        <el-table-column
          :label="$t('sales_orders.soNumber')"
          prop="soNumber"
          fixed
          width="150"
          sortable="custom">
          <template slot-scope="scope">
            <PortausLink path="/sales-orders/" :id="scope.row.id" :label="scope.row.soNumber" fs="fs-12"></PortausLink>
          </template>
        </el-table-column>
        <el-table-column
          v-if="customerId==null"
          prop="customer.usual_name"
          sortable="custom"
          width="300"
          :label="$t('sales_orders.customer')">
          <template slot-scope="scope">
            <PortausLink path="/customers/" :id="scope.row.customer.id" :label="customerName(scope.row.customer)" fs="fs-12"></PortausLink>
          </template>
        </el-table-column>
        <el-table-column
          v-if="customerId!=null"
          prop="rep.name"
          sortable="custom"
          :label="$t('sales_orders.rep')">
          <template slot-scope="scope">
              <span v-if="scope.row.rep" style="word-break: break-word;" class="fs-12">{{scope.row.rep.firstName}} {{scope.row.rep.lastName}}</span>
              <span v-else class="fs-12"> -- </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('sales_orders.date')"
          prop="date"
          width="100"
          sortable="custom">
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.date" class="fs-12">{{_moment(scope.row.date)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showDeliveryDate"
          :label="$t('sales_orders.deliveryDate')"
          prop="expectedDeliveryDate"
          width="160"
          sortable="custom">
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.expectedDeliveryDate" class="fs-12">{{_moment(scope.row.expectedDeliveryDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column
        :label="$t('sales_orders.deliveryType')"
          prop="delivery_type"
          width="200"
          sortable="custom">
          <template slot-scope="scope">
            <span style="word-break: break-word;" v-if="scope.row.deliveryType" class="fs-12">{{scope.row.deliveryType.code}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status.code"
          :label="$t('sales_orders.status')"
          width="200"
          sortable="custom">
          <template slot-scope="scope">
            <SalesOrderStatusTag :status="scope.row.status" class="pr-10"/>
          </template>
        </el-table-column>
        <el-table-column
        :label="$t('sales_orders.tags')">
          <template slot-scope="scope">
            <el-tag v-for="t in scope.row.tags" :key="t.id"  size="small">{{t.code}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="hidden-lg-and-up">
      <div v-for="so in salesOrders" :key="so.id">
        <SalesOrderTile @click="openSalesOrder(so.id)" :positive="isPositive(so)" :intermediary="isIntermediary(so)" :negative="isNegative(so)" :customer="so.customer" :shipping_contact="so.shippingContact" :so_number="so.soNumber" :reference="so.reference" :date="so.date" :total="so.total" :status="so.status" :sales_rep="so.rep"></SalesOrderTile>
        <el-divider />
      </div>
    </div> -->
  </div>
</template>
<script>
import moment from 'moment-business-days'
import SalesOrderTile from '@/components/salesOrder/Sales-order-tile'
import PortausLink from '@/components/portaus-link'
import SalesUtils from '@/utils/sales-utils'
import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'

export default {
  name: 'sales-order-table',
	props: {
    salesOrders : Array,
    customerId : String,
    height : {
      type : [String, Number],
      default : 250
    },
    showDeliveryDate : {
      type : Boolean,
      default : false
    },
    sortProp: {
      type: String,
      default: 'date'
    },
    sortOrder: {
      type: String,
      default: 'ascending'
    }
	},
  data() {
    return {
      type : 'SET_ASIDE',
      loading : false,
      user : null
    };
  },components: {
    SalesOrderTile,
    PortausLink,
    SalesOrderStatusTag
  },
  watch : {

  },
	methods: {
    isB2B(salesOrder) {
        return _.get(salesOrder, 'origin') === 'B2B';
      },
    customerName(customer){
      return customer.usualName!=null?customer.usualName:customer.name;
    },
    _moment(datetime, format='DD/MM/YYYY'){
      return moment(datetime).format(format);

    },
    date(so){
      if(this.filters){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        return status.status_log.created_at;
      }else{
        return so.date;
      }

    },
    isPositive(so){
      return SalesUtils.isPositive(so);

    },
    isNegative(so){
      return SalesUtils.isNegative(so);

    },isIntermediary(so){
      return SalesUtils.isIntermediary(so);

    },
    openSalesOrder(salesOrderId){
      var index='/sales-orders/'+salesOrderId;
      this.$router.push(index);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
      this.$router.push(index);
    },
    handleSortChange({ prop, order }) {
      this.$emit('sort-change', { prop, order });
    }
	},
	computed: {

	}
}
</script>
<style lang="scss" scoped>




</style>
